<template>

  <b-form-group
    :label="label"
    :label-for="id"
    class="bold-label mb-4"
    :state="inputValue.state"
    :invalid-feedback="inputValue.invalidFeedback">
    <div v-if="info">{{info}}</div>
    <b-form-input
      :id="id"
      type="text"
      :maxlength="maxLength"
      :placeholder="placeholder"
      autocomplete="off"
      @input="onChange"
      v-model="inputValue.value"
      :required="isRequired"
      :disabled="isDisabled"
      :state="inputValue.state"
      @keydown.down="onArrowDown"
      @keydown.up="onArrowUp"
      v-on:keydown.enter.prevent="onEnter"/>
    <b-form-text>{{helpMessage}}</b-form-text>
    <ul id="autocomplete-elements" v-show="isOpen" class="autocomplete-elements">
      <li v-for="(element, i) in elements" :key="i" @click=setElement(element)
          class="autocomplete-element" :class="{ 'is-active': i === arrowCounter }">
        {{ element.tostring }}
      </li>
    </ul>
  </b-form-group>

</template>

<script>

export default {

  name: 'AutocompleteField',

  props : {
    inputValue: {
      type: Object,
      default: null
    },
    label: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'input'
    },
    items: {
      type: Array,
      default: () => []
    },
    maxLength: {
      type: Number,
      default: 250
    },
    placeholder: {
      type: String,
      default: null
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: null
    },
    helpMessage: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      isOpen: false,
      elements: [],
      arrowCounter: -1
    };
  },

  watch: {
    items: function (value, oldValue) {
      if(value.length !== oldValue.length) {
        this.elements = value
      }
    }
  },

  mounted() {
    this.elements = this.items
    document.addEventListener('click', this.handleClickOutside)
  },

  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },

  methods: {
    setElement(element) {
      this.inputValue.value = element.name
      this.isOpen =  false
      this.emitChangeSelectedValue(element)
    },

    filterElements() {
      this.elements = this.items.filter((item) => {
        return item.tostring.toLowerCase().indexOf(this.inputValue.value.toLowerCase()) > -1
      })
    },

    onChange() {
      this.filterElements()
      this.isOpen = true
    },

    handleClickOutside(event) {
      if (!this.$el.contains(event.target)) {
        this.isOpen = false
        this.arrowCounter = -1
      }
    },

    onArrowDown() {
      if (this.arrowCounter < this.elements.length) {
        this.arrowCounter = this.arrowCounter + 1
      }
    },
    onArrowUp() {
      if (this.arrowCounter > 0) {
        this.arrowCounter = this.arrowCounter - 1
      }
    },
    onEnter() {
      if (this.arrowCounter !== -1) {
        this.inputValue.value = this.elements[this.arrowCounter].name
      }
      this.isOpen = false;
      this.arrowCounter = -1;
      this.emitChangeSelectedValue(this.elements[this.arrowCounter])
    },

    emitChangeSelectedValue (selectedElement) {
      this.$emit('elementValueChanged', selectedElement)
    }
  }
};

</script>

<style>

.autocomplete-elements {
  padding: 0;
  margin: 0;
  border: 1px solid var(--main-border-color);
  background: var(--main-white);
  position: absolute;
  z-index: 1;
  min-width: 25%;
}

.autocomplete-element {
  list-style: none;
  text-align: left;
  padding: 4px 10px;
  cursor: pointer;
}

.autocomplete-element.is-active,
.autocomplete-element:hover {
  background-color: var(--main-grey);
  color: white;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/b122/editFields/AutocompleteField.vue